import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import 'air-datepicker/air-datepicker.css';
import '../../sass/frontend/components/datepicker.scss';

/*
 * Swaps native <input type="date" data-datepicker> fields for Air Datepicker.
 * The original input becomes hidden and keeps its name, still posting Y-m-d to
 * the server; the visitor sees and picks a dd/mm/yyyy date. Without JS the
 * native date input is left as it is.
 */
document.querySelectorAll('input[type="date"][data-datepicker]').forEach(function (field) {
    const display = document.createElement('input');
    display.type = 'text';
    display.id = field.id;
    display.className = field.className + ' datepicker-input';
    display.placeholder = field.placeholder;
    display.disabled = field.disabled;
    display.readOnly = true;
    display.autocomplete = 'off';

    field.id = field.id + '_value';
    field.type = 'hidden';
    field.before(display);

    // Restore a value posted back after a validation error
    const [y, m, d] = (field.value || '').split('-').map(Number);

    new AirDatepicker(display, {
        locale: Object.assign({}, localeEn, {firstDay: 1}),
        dateFormat: 'dd/MM/yyyy',
        altField: field,
        altFieldDateFormat: 'yyyy-MM-dd',
        minDate: new Date(),
        selectedDates: y && m && d ? [new Date(y, m - 1, d)] : [],
        buttons: ['today', 'clear'],
        // Re-tapping the chosen day shouldn't wipe it - easy to do on mobile where
        // the picker opens under your finger. The Clear button is there for that
        toggleSelected: false,
        autoClose: true,
        isMobile: window.matchMedia('(max-width: 575.98px)').matches,
    });
});
